import * as React from "react";
const SvgAdd = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M21,10.8H12.8V3a1,1,0,0,0-2,0v7.8H3a1,1,0,0,0,0,2h7.8V21a1,1,0,0,0,2,0V12.8H21a1,1,0,0,0,0-2Z" }));
export default SvgAdd;
